import { render } from "./change-password-modal.vue?vue&type=template&id=55774321"
import script from "./change-password-modal.vue?vue&type=script&lang=js"
export * from "./change-password-modal.vue?vue&type=script&lang=js"
script.render = render

export default script